import { render } from "./RankingOwner.vue?vue&type=template&id=6781e484"
import script from "./RankingOwner.vue?vue&type=script&lang=js"
export * from "./RankingOwner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__